import { Nav, NavItem, Button, Collapse } from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { wipeTestData } from "../api/adminApi";
import "./StaffSidebar.css";

const navigation = [
  {
    title: "Bursary",
    icon: "bi bi-patch-check",
    hasDropdown: true,
    children: [
      {
        title: "BMO Master",
        href: "/backoffice-dashboard/ManageBMOs",
        icon: "bi bi-building",
      },
      {
        title: "Funders",
        href: "/backoffice-dashboard/ManageFunders",
        icon: "bi bi-bank",
      },
      {
        title: "Bursaries",
        href: "/backoffice-dashboard/Bursaries",
        icon: "bi bi-cash-stack",
      },
      {
        title: "Components",
        href: "/backoffice-dashboard/BursaryComponents",
        icon: "bi bi-boxes",
      },
      {
        title: "Global Benefits",
        href: "/backoffice-dashboard/GlobalBenefits",
        icon: "bi bi-globe",
      }
    ]
  },
  {
    title: "Accommodations",
    icon: "bi bi-house",
    hasDropdown: true,
    children: [
      {
        title: "Global Amenities",
        href: "/backoffice-dashboard/GlobalAmenities",
        icon: "bi bi-stars",
      }
    ]
  },
  {
    title: "Tutoring",
    icon: "bi bi-mortarboard",
    hasDropdown: true,
    children: [
      {
        title: "Tutoring Providers",
        href: "/backoffice-dashboard/TutoringProviders",
        icon: "bi bi-people",
      },
      {
        title: "Subjects",
        href: "/backoffice-dashboard/Subjects",
        icon: "bi bi-book",
      }
    ]
  },
  {
    title: "Partners",
    href: "/backoffice-dashboard/Institutions",
    icon: "bi bi-building",
  },
  {
    title: "Institutions",
    href: "/backoffice-dashboard/ManageInstitutions",
    icon: "bi bi-card-text",
  },
  {
    title: "Campuses",
    href: "/backoffice-dashboard/ManageCampuses",
    icon: "bi bi-columns",
  },
  {
    title: "Providers",
    href: "/backoffice-dashboard/ManageProviders",
    icon: "bi bi-link",
  },
  {
    title: "Property Applications",
    href: "/backoffice-dashboard/ManagePropertyApplications",
    icon: "bi bi-building-check",
  },
  {
    title: "Students",
    href: "/backoffice-dashboard/ManageStudents",
    icon: "bi bi-people",
  },
  {
    title: "Bookings",
    href: "/backoffice-dashboard/Bookings",
    icon: "bi bi-calendar-check",
  },
  {
    title: "Permissions",
    href: "/backoffice-dashboard/PermissionManagement",
    icon: "bi bi-shield-check",
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userEmail } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState({});
  
  const handleWipeTestData = async () => {
    const confirmMessage = `⚠️ WARNING: This will permanently delete ALL test data!

This includes:
• All BMOs and their representatives
• All Funders and their data  
• All Bursaries and Beneficiaries
• All Students and Accommodation Vouchers
• All related user accounts (except admin/back office)

Are you absolutely sure you want to proceed?`;

    if (window.confirm(confirmMessage)) {
      const finalConfirm = window.confirm("FINAL CONFIRMATION: This action cannot be undone! Are you 100% certain?");
      
      if (finalConfirm) {
        try {
          const result = await wipeTestData();
          alert(`✅ Success! Test data wiped successfully!\n\nDeleted:\n• ${result.deleted.bmos} BMOs\n• ${result.deleted.funders} Funders\n• ${result.deleted.bursaries} Bursaries\n• ${result.deleted.beneficiaries} Beneficiaries\n• ${result.deleted.students} Students\n• ${result.deleted.vouchers} Vouchers\n• ${result.deleted.users} Users`);
          
          // Optionally reload the page to refresh the UI
          window.location.reload();
        } catch (error) {
          console.error('Error wiping test data:', error);
          
          // Log detailed error info to console
          if (error.response?.data) {
            console.log('Detailed Error Response:', error.response.data);
            if (error.response.data.traceback) {
              console.log('Python Traceback:', error.response.data.traceback);
            }
          }
          
          // Show detailed error in alert
          const errorMessage = error.response?.data?.error || error.message;
          const errorType = error.response?.data?.error_type || 'Unknown';
          
          alert(`❌ Error wiping test data:\n\nType: ${errorType}\nMessage: ${errorMessage}\n\nCheck browser console for detailed traceback.`);
        }
      }
    }
  };

  const toggleDropdown = (index) => {
    setDropdownOpen(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  
  const closeSidebar = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
  };

  return (
    <div className="p-3">
      {/* Mobile close button - only visible on small screens */}
      <div className="d-flex justify-content-end d-lg-none mb-2">
        <Button
          color="link"
          size="sm"
          className="text-dark p-1"
          onClick={closeSidebar}
          style={{ border: 'none' }}
        >
          <i className="bi bi-x-lg" style={{ fontSize: '1.2rem', color: '#000' }}></i>
        </Button>
      </div>
      
      <div className="d-flex align-items-center">
        {/* <Logo /> */}
      </div>
      <div className="pt-4 mt-2">
        <Nav vertical className="sidebarNav">
          {navigation.map((navi, index) => (
            <NavItem key={index} className="sidenav-bg">
              {navi.hasDropdown ? (
                <>
                  <div
                    className="nav-link py-3 d-flex justify-content-between align-items-center dropdown-parent"
                    style={{ 
                      color: "#000", 
                      cursor: "pointer",
                      backgroundColor: dropdownOpen[index] ? "rgb(230 238 248)" : "transparent",
                      fontSize: navi.title.length > 12 ? "12px" : "inherit",
                      fontWeight: navi.title.length > 12 ? "600" : "normal"
                    }}
                    onClick={() => toggleDropdown(index)}
                  >
                    <div>
                      <i className={navi.icon} style={{ color: "#000" }}></i>
                      <span className="ms-3 d-inline-block">{navi.title}</span>
                    </div>
                    <i className={`bi ${dropdownOpen[index] ? 'bi-chevron-up' : 'bi-chevron-down'}`} 
                       style={{ color: "#000" }}></i>
                  </div>
                  <Collapse isOpen={dropdownOpen[index]}>
                    <div style={{ backgroundColor: "rgb(230 238 248)", borderRadius: "4px", margin: "0 8px" }}>
                      {navi.children && navi.children.map((child, childIndex) => (
                        <Link
                          key={childIndex}
                          to={child.href}
                          className="nav-link py-2 ps-3"
                          style={{ 
                            color: "#000", 
                            fontSize: child.title.length > 12 ? "12px" : "0.9rem",
                            fontWeight: child.title.length > 12 ? "600" : "normal",
                            backgroundColor: "transparent"
                          }}
                          onClick={() => navigate(child.href)}
                        >
                          <i className={child.icon} style={{ color: "#000" }}></i>
                          <span className="ms-2 d-inline-block">{child.title}</span>
                        </Link>
                      ))}
                    </div>
                  </Collapse>
                </>
              ) : (
                <Link
                  to={navi.href}
                  className={
                    location.pathname === navi.href
                      ? "nav-link py-3"
                      : "nav-link py-3"
                  }
                  style={{ 
                    color: "#000",
                    fontSize: navi.title.length > 12 ? "12px" : "inherit",
                    fontWeight: navi.title.length > 12 ? "600" : "normal"
                  }}
                >
                  <i className={navi.icon} style={{ color: "#000" }}></i>
                  <span className="ms-3 d-inline-block">{navi.title}</span>
                </Link>
              )}
            </NavItem>
          ))}
          
          {/* Show Wipe Test Data button only for admin@administrator.com */}
          {userEmail === 'admin@administrator.com' && (
            <NavItem className="mt-4">
              <hr style={{ borderColor: "#ccc", margin: "1rem 0" }} />
              <div className="text-center">
                <small className="text-muted d-block mb-2">🧹 Demo Preparation Tools</small>
                <Button
                  color="danger"
                  size="sm"
                  className="w-100"
                  onClick={handleWipeTestData}
                  title="Wipe all test data for client demo"
                  style={{ 
                    backgroundColor: "#dc3545", 
                    borderColor: "#dc3545",
                    fontSize: "0.875rem",
                    fontWeight: "600"
                  }}
                >
                  <i className="bi bi-trash3 me-2"></i>
                  Wipe All Test Data
                </Button>
                <small className="text-muted d-block mt-2" style={{fontSize: '0.75rem'}}>
                  ⚠️ For demo preparation only
                </small>
              </div>
            </NavItem>
          )}
        </Nav>
      </div>
    </div>
  );
};

export default Sidebar;
